module.exports = __webpack_public_path__ + "img/40f9c35.png";